<template>
      <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="nav-bar box-horizontal mb-0">
                      <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
                      <div class="flex-1">
                        <h3 class="m-0">Pengaduan</h3>
                        <p class="mb-0">Semua pengaduan akan muncul disini</p>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-md-12">
                        <button class="btn btn-success" @click="theGet.datae('selesai')">Pengaduan Selesai</button>
                      </div>
                    </div>
                    <div class="card mt-2">
                      <div class="card-body">
                          <div class="table-responsive">
                          <table class="table">
                              <thead class="text-info">
                                <th>Tanggal</th>
                                <th>Nama Pelanggan</th>
                                <th>Area</th>
                                <th>Status</th>
                                <th>Keluhan</th>
                                <th>Rincian</th>
                              </thead>
                              <!-- LOADING -->
                              <tbody v-show="dataAll.loading">
                              <tr>
                                  <td colspan="8"><Loading></Loading></td>
                              </tr>
                              <tr>
                                  <td colspan="8"><Loading></Loading></td>
                              </tr>
                              <tr>
                                  <td colspan="8"><Loading></Loading></td>
                              </tr>
                              </tbody>
                              <!-- DATA -->
                              <tbody v-show="!dataAll.loading">
                              <tr v-for="(u, index) in theGet.data.List">
                                  <td>
                                    <span class="d-block">{{myGlobal.tglIndo(u.tanggal)}}</span>
                                    <span class="d-block">{{u.jam}}</span>
                                  </td>
                                  <td>
                                    <span class="d-block">{{u.nama}}</span>
                                    <span class="d-block">{{u.wa}}</span>
                                  </td>
                                  <td>
                                    {{u.area}}
                                  </td>
                                  <td>
                                      <div v-if="u.status == 'pending' || u.status == null">
                                        <span class="d-block text-warning">Pending</span>
                                        <span class="d-block text-gray">{{u.jam}} - {{ myGlobal.tglIndo(u.tanggal) }}</span>
                                      </div>
                                      <div v-else-if="u.status == 'proses'">
                                        <span class="d-block text-info">Proses</span>
                                        <span class="d-block text-gray">{{u.jam_proses}} - {{ myGlobal.tglIndo(u.tgl_proses) }}</span>
                                      </div>
                                      <div v-else-if="u.status == 'selesai'">
                                        <span class="d-block text-success">Selesai</span>
                                        <span class="d-block text-gray">{{u.jam_selesai}} - {{ myGlobal.tglIndo(u.tgl_selesai) }}</span>
                                      </div>
                                  </td>
                                  <td>
                                    {{u.text.substring(0,15)}}...
                                  </td>
                                  <td>
                                    <button class="btn btn-sm btn-primary" @click="theGet.rincian(u)">Rincian</button>
                                  </td>
                              </tr>
                              <!-- NULL -->
                              <tr v-if="theGet.data.List == null">
                                  <td></td>
                                  <td>Tidak ada Data </td>
                              </tr>
                              </tbody>
                          </table>
                          </div>
                      </div>
                    </div>
                </div>
                
            </div>
        </div>

        <!-- MODAL -->
        <div class="modal" tabindex="-1" role="dialog" v-show="dataAll.modalDetail">
            <div class="overlay"></div>
            <div class="modal-dialog" role="document" v-if="dataAll.modalData != null">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Rincian Pengaduan</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="dataAll.modalDetail = false">
                    <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" style="height: 500px; overflow: auto">
                    <div class="row">
                      <div class="col-md-12">
                        <label for="" class="text-secondary">Pelanggan</label>
                        <p class="mb-0">{{dataAll.modalData.nama}}</p>
                        <p class="">{{dataAll.modalData.wa}}</p>
                      </div>
                      <div class="col-md-12">
                        <label for="" class="text-secondary">Area</label>
                        <p class="">{{dataAll.modalData.area}}</p>
                      </div>
                      <div class="col-md-12">
                        <label for="" class="text-secondary">Alamat</label>
                        <p class="">{{dataAll.modalData.alamat}}</p>
                      </div>
                      <div class="col-md-12">
                        <label for="" class="text-secondary d-block">Status</label>
                        <p class="text-warning" v-if="dataAll.modalData.status == 'pending' || dataAll.modalData.status == null">Pending</p>
                        <p class="text-info" v-else-if="dataAll.modalData.status == 'proses'">Proses</p>
                        <p class="text-success" v-else>Done</p>
                      </div>
                      <div class="col-md-12 mb-3">
                        <label for="" class="text-secondary d-block">Jam & Tanggal</label>
                        <span class="">{{dataAll.modalData.jam}} - {{myGlobal.tglIndo(dataAll.modalData.tanggal)}}</span>
                      </div>
                      <div class="col-md-12">
                        <label for="" class="text-secondary d-block">Keluhan</label>
                        <p class="text-danger">{{dataAll.modalData.text}}</p>
                      </div>
                      <div class="col-md-12" v-if="dataAll.modalData.kerusakan != null">
                        <label for="" class="text-secondary d-block">Kerusakan</label>
                        <p class="text-warning">{{dataAll.modalData.kerusakan}}</p>
                      </div>
                      <div class="col-md-12" v-if="dataAll.modalData.teknisi != null">
                        <label for="" class="text-secondary d-block">Teknisi</label>
                        <p class="">{{dataAll.modalData.teknisi}}</p>
                      </div>

                      <!--
                      <div class="col-md-12" v-if="dataAll.modalData.ur_id != null">
                        <label for="" class="text-secondary d-block">Pelanggan</label>
                        <p>{{dataAll.detailPel}} - {{data.detailPelWA}} - {{dataAll.detailPelArea}}</p>
                      </div>
                      -->
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-info" @click="dataAll.modalDetail = false">Okelah</button>
                  </div>
              </div>
          </div>
        </div>


      </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 

export default {
  name: 'Beranda',
	components: { 
      "Loading" : Loading
	}, 
  setup() {
    const dataAll = reactive({
        loading: true,
        modalDetail: false,
        modalData: null
    })

    const theGet = {
      data: reactive({
          List: [],
      }),
      datae(status) {
        var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          stat: status
        };
    
        var apiUrl = inter.Pengaduan();
        myGlobal.call(datax,apiUrl).then(x => {
          
          //console.log(JSON.stringify(x));

          dataAll.loading = false;

          if (x.status == true) {
            this.data.List = x.data;
          } else {
            theGet.data.List = null;
          }

        })
      },
      rincian(data) {
        //console.log(JSON.stringify(data));
        dataAll.modalData = data;
        dataAll.modalDetail = true;
      }
    }
    return {
      dataAll,
      myGlobal,
      theGet
    }
  },
  mounted () {
    document.title = "Pengaduan";

    this.dataAll.namaQ = sessionStorage.getItem('admin');
    this.theGet.datae("pending");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
  display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/pengaduan/main.vue